/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refinedone1Inputs */

const en_refinedone1 = /** @type {(inputs: Refinedone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image refined and saved to your media library.`)
};

const de_refinedone1 = /** @type {(inputs: Refinedone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild verfeinert und in deiner Mediathek gespeichert.`)
};

/**
* | output |
* | --- |
* | "Image refined and saved to your media library." |
*
* @param {Refinedone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refinedone1 = /** @type {((inputs?: Refinedone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refinedone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refinedone1(inputs)
	return de_refinedone1(inputs)
});
export { refinedone1 as "refineDone" }